
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/building-calculator",
      function () {
        return require("private-next-pages/building-calculator/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/building-calculator"])
      });
    }
  